import { render } from "./favorites.svg?vue&type=template&id=279a68cb"
const script = {}
script.render = render

export default script